import { c as _c } from "react/compiler-runtime";
import { Avatar, Badge, Button, HStack, Icon, Separator, Text, VStack, Wrap } from '@chakra-ui/react';
import { AiAvatarBadge } from '@src/components/sco/Account/UserAvatar';
import { WilWhoIsModal } from '@src/components/sco/Advisors/modals/WilWhoIsModal';
import { bookMeetingHrefForAdvisor, bookMeetingLabelForAdvisor } from '@src/components/sco/Advisors/model/access';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { PaywalledAdvisorAction } from '@src/components/sco/Advisors/shared/PaywalledAdvisorAction';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { askAdvisorsHref, engagementChatHref, engagementToBaseballCard, memberProfileHref } from '@src/components/sco/Advisors/utils/mapEngagements';
import { bookSessionLabel } from '@src/components/sco/Advisors/utils/sessionFormat';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ADVISOR_ENGAGEMENT_SOURCE_TEAM } from '@src/constants/advisor-engagement-sources';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import moment from 'moment/moment';
import { ReactNode, useState } from 'react';
import { LuBriefcase, LuBuilding, LuCalendar, LuClock, LuLinkedin, LuMapPin, LuMessageSquare, LuSparkles } from 'react-icons/lu';
const DetailRow = t0 => {
  const $ = _c(12);
  const {
    icon,
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <Icon boxSize={4} color="colorPalette.fg/50" marginTop={0.5}>{icon}</Icon>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Text color="colorPalette.fg/50" textStyle="label2xs">{label}</Text>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = typeof children === "string" ? <Text color="colorPalette.fg/80" fontSize="sm" fontWeight="medium">{children}</Text> : children;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <VStack align="flex-start" flex={1} gap={0.5} minWidth={0}>{t2}{t3}</VStack>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <HStack align="flex-start" gap={2} width="full">{t1}{t4}</HStack>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const AdvisorMiniProfile = t0 => {
  const $ = _c(112);
  const {
    engagement
  } = t0;
  const paths = useAdvisorsPaths();
  const [wilWhoIsOpen, setWilWhoIsOpen] = useState(false);
  let advisorProfile;
  let advisorUser;
  let advisorUserId;
  let bookMeetingHref;
  let card;
  let profileHref;
  let t1;
  if ($[0] !== engagement || $[1] !== paths.base) {
    card = engagementToBaseballCard(engagement, {
      base: paths.base
    });
    let t2;
    if ($[9] !== engagement) {
      t2 = memberProfileHref(engagement);
      $[9] = engagement;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    profileHref = t2;
    advisorUserId = engagement.advisorUserId || engagement.advisorUser?.userId;
    advisorUser = engagement.advisorUser;
    advisorProfile = advisorUser?.advisorProfile;
    bookMeetingHref = bookMeetingHrefForAdvisor({
      name: card.name,
      isAI: !!engagement.isAI,
      userId: advisorUserId,
      sessionBookingUrl: advisorProfile?.sessionBookingUrl
    });
    t1 = bookMeetingLabelForAdvisor(card.name);
    $[0] = engagement;
    $[1] = paths.base;
    $[2] = advisorProfile;
    $[3] = advisorUser;
    $[4] = advisorUserId;
    $[5] = bookMeetingHref;
    $[6] = card;
    $[7] = profileHref;
    $[8] = t1;
  } else {
    advisorProfile = $[2];
    advisorUser = $[3];
    advisorUserId = $[4];
    bookMeetingHref = $[5];
    card = $[6];
    profileHref = $[7];
    t1 = $[8];
  }
  const bookMeetingLabel = t1;
  let t2;
  if ($[11] !== advisorProfile?.canAcceptSessions || $[12] !== advisorUserId || $[13] !== paths) {
    t2 = advisorProfile?.canAcceptSessions && advisorUserId ? paths.withQuery(paths.sessionNew, {
      expertUserId: advisorUserId
    }) : null;
    $[11] = advisorProfile?.canAcceptSessions;
    $[12] = advisorUserId;
    $[13] = paths;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const paidSessionHref = t2;
  let t3;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = bookSessionLabel();
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const paidSessionLabel = t3;
  let t4;
  if ($[16] !== advisorUserId || $[17] !== engagement || $[18] !== paths.base) {
    t4 = engagement.isAI ? engagementChatHref(engagement, paths.base) : askAdvisorsHref(advisorUserId, paths.base);
    $[16] = advisorUserId;
    $[17] = engagement;
    $[18] = paths.base;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const messageHref = t4;
  const isTeamAdvisor = !engagement.isAI && engagement.sourceKey === ADVISOR_ENGAGEMENT_SOURCE_TEAM;
  let t5;
  if ($[20] !== engagement.isAI) {
    t5 = engagement.isAI ? <LuSparkles /> : <LuMessageSquare />;
    $[20] = engagement.isAI;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = engagement.isAI ? `Ask ${card.name}` : "Message";
  let t7;
  if ($[22] !== messageHref || $[23] !== t5 || $[24] !== t6) {
    t7 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={messageHref}>{t5}{t6}</NextLink></Button>;
    $[22] = messageHref;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const messageButton = t7;
  const location = advisorUser?.location;
  const linkedin = advisorUser?.linkedin;
  const lastActiveAt = advisorUser?.lastActiveAt;
  const company = advisorUser?.company;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t8;
  let t9;
  if ($[26] !== advisorProfile?.availabilityHoursPerMonth || $[27] !== advisorProfile?.categories || $[28] !== advisorUser?.userSkills || $[29] !== card.avatarUrl || $[30] !== card.bio || $[31] !== card.isAI || $[32] !== card.name || $[33] !== card.role || $[34] !== card.rolePalette || $[35] !== company || $[36] !== engagement.advisorUser?.pictureUrl || $[37] !== engagement.isAI || $[38] !== lastActiveAt || $[39] !== linkedin || $[40] !== location) {
    const industries = (company?.industries || []).filter(Boolean);
    const availabilityHours = advisorProfile?.availabilityHoursPerMonth;
    const specialties = (advisorProfile?.categories || []).filter(Boolean);
    const topSkills = (advisorUser?.userSkills || []).filter(Boolean).slice().sort(_temp).slice(0, 4);
    const hasDetails = !engagement.isAI && (location || linkedin || lastActiveAt || company?.name || industries.length > 0 || availabilityHours || specialties.length > 0 || topSkills.length > 0);
    T0 = VStack;
    t8 = "stretch";
    t9 = 4;
    t10 = "full";
    let t15;
    if ($[49] !== card.isAI) {
      t15 = card.isAI ? <Icon boxSize={5}><LuSparkles /></Icon> : null;
      $[49] = card.isAI;
      $[50] = t15;
    } else {
      t15 = $[50];
    }
    let t16;
    if ($[51] !== card.name || $[52] !== t15) {
      t16 = <Avatar.Fallback name={card.name}>{t15}</Avatar.Fallback>;
      $[51] = card.name;
      $[52] = t15;
      $[53] = t16;
    } else {
      t16 = $[53];
    }
    const t17 = card.avatarUrl || engagement.advisorUser?.pictureUrl || undefined;
    let t18;
    if ($[54] !== t17) {
      t18 = <Avatar.Image src={t17} />;
      $[54] = t17;
      $[55] = t18;
    } else {
      t18 = $[55];
    }
    let t19;
    if ($[56] !== card.isAI) {
      t19 = card.isAI ? <AiAvatarBadge /> : null;
      $[56] = card.isAI;
      $[57] = t19;
    } else {
      t19 = $[57];
    }
    let t20;
    if ($[58] !== card.rolePalette || $[59] !== t16 || $[60] !== t18 || $[61] !== t19) {
      t20 = <Avatar.Root colorPalette={card.rolePalette} size="2xl">{t16}{t18}{t19}</Avatar.Root>;
      $[58] = card.rolePalette;
      $[59] = t16;
      $[60] = t18;
      $[61] = t19;
      $[62] = t20;
    } else {
      t20 = $[62];
    }
    let t21;
    if ($[63] !== card.name) {
      t21 = <Text fontSize="lg" fontWeight="semibold" lineHeight="short">{card.name}</Text>;
      $[63] = card.name;
      $[64] = t21;
    } else {
      t21 = $[64];
    }
    let t22;
    if ($[65] !== card.role || $[66] !== card.rolePalette) {
      t22 = <SpecialtyTag colorPalette={card.rolePalette} label={card.role} />;
      $[65] = card.role;
      $[66] = card.rolePalette;
      $[67] = t22;
    } else {
      t22 = $[67];
    }
    let t23;
    if ($[68] !== t21 || $[69] !== t22) {
      t23 = <VStack gap={1}>{t21}{t22}</VStack>;
      $[68] = t21;
      $[69] = t22;
      $[70] = t23;
    } else {
      t23 = $[70];
    }
    if ($[71] !== t20 || $[72] !== t23) {
      t11 = <VStack align="center" gap={2} textAlign="center">{t20}{t23}</VStack>;
      $[71] = t20;
      $[72] = t23;
      $[73] = t11;
    } else {
      t11 = $[73];
    }
    if ($[74] !== card.bio) {
      t12 = <Text color="colorPalette.fg/70" fontSize="sm" lineClamp={4} marginX="auto" maxWidth="80%" textAlign="center">{card.bio}</Text>;
      $[74] = card.bio;
      $[75] = t12;
    } else {
      t12 = $[75];
    }
    if ($[76] !== engagement.isAI || $[77] !== lastActiveAt) {
      t13 = lastActiveAt && !engagement.isAI ? <Text color="colorPalette.fg/40" fontSize="xs" textAlign="center">Last active {moment(lastActiveAt).fromNow()}</Text> : null;
      $[76] = engagement.isAI;
      $[77] = lastActiveAt;
      $[78] = t13;
    } else {
      t13 = $[78];
    }
    t14 = hasDetails ? <VStack align="stretch" bgColor="colorPalette.panel" border="1px solid" borderColor="colorPalette.border/40" borderRadius="lg" gap={3} padding={4} separator={<Separator />} width="full">{location ? <DetailRow icon={<LuMapPin />} label="Location">{location}</DetailRow> : null}{company?.name ? <DetailRow icon={<LuBriefcase />} label="Company"><HStack gap={2}><Avatar.Root borderRadius="full" boxShadow="none" size="2xs"><Avatar.Fallback><LuBriefcase /></Avatar.Fallback><Avatar.Image src={company.logoUrl || undefined} /></Avatar.Root><Text color="colorPalette.fg/80" fontSize="sm" fontWeight="medium">{company.name}</Text></HStack></DetailRow> : null}{industries.length > 0 ? <DetailRow icon={<LuBuilding />} label={industries.length > 1 ? "Industries" : "Industry"}>{industries.map(_temp2).join(", ")}</DetailRow> : null}{linkedin ? <DetailRow icon={<LuLinkedin />} label="LinkedIn"><Text asChild={true} color="yellow.500" fontSize="sm" fontWeight="medium" lineClamp={1}><NextLink href={linkedin} target="_blank">{linkedin.replace(/^https?:\/\/(www\.)?/, "")}</NextLink></Text></DetailRow> : null}{availabilityHours ? <DetailRow icon={<LuClock />} label="Availability">{`${availabilityHours} hrs / month`}</DetailRow> : null}{specialties.length > 0 ? <VStack align="flex-start" gap={1.5} width="full"><Text color="colorPalette.fg/50" textStyle="label2xs">Specialties</Text><Wrap gap={1.5}>{specialties.map(_temp3)}</Wrap></VStack> : null}{topSkills.length > 0 ? <VStack align="flex-start" gap={1.5} width="full"><Text color="colorPalette.fg/50" textStyle="label2xs">Top skills</Text><Wrap gap={1.5}>{topSkills.map(_temp4)}</Wrap></VStack> : null}</VStack> : null;
    $[26] = advisorProfile?.availabilityHoursPerMonth;
    $[27] = advisorProfile?.categories;
    $[28] = advisorUser?.userSkills;
    $[29] = card.avatarUrl;
    $[30] = card.bio;
    $[31] = card.isAI;
    $[32] = card.name;
    $[33] = card.role;
    $[34] = card.rolePalette;
    $[35] = company;
    $[36] = engagement.advisorUser?.pictureUrl;
    $[37] = engagement.isAI;
    $[38] = lastActiveAt;
    $[39] = linkedin;
    $[40] = location;
    $[41] = T0;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = t8;
    $[48] = t9;
  } else {
    T0 = $[41];
    t10 = $[42];
    t11 = $[43];
    t12 = $[44];
    t13 = $[45];
    t14 = $[46];
    t8 = $[47];
    t9 = $[48];
  }
  let t15;
  if ($[79] !== engagement.isAI || $[80] !== isTeamAdvisor || $[81] !== messageButton) {
    t15 = engagement.isAI ? messageButton : <PaywalledAdvisorAction isTeamAdvisor={isTeamAdvisor} upgradeCtaButtonProps={{
      size: "sm",
      width: "full"
    }}>{messageButton}</PaywalledAdvisorAction>;
    $[79] = engagement.isAI;
    $[80] = isTeamAdvisor;
    $[81] = messageButton;
    $[82] = t15;
  } else {
    t15 = $[82];
  }
  let t16;
  if ($[83] !== engagement.isAI || $[84] !== paidSessionHref) {
    t16 = !engagement.isAI && paidSessionHref ? <Button asChild={true} size="sm" variant="outlineSolid" width="full"><NextLink href={paidSessionHref}>{paidSessionLabel}</NextLink></Button> : null;
    $[83] = engagement.isAI;
    $[84] = paidSessionHref;
    $[85] = t16;
  } else {
    t16 = $[85];
  }
  let t17;
  if ($[86] !== bookMeetingHref || $[87] !== bookMeetingLabel || $[88] !== engagement.isAI) {
    t17 = !engagement.isAI && bookMeetingHref ? <Button asChild={true} size="sm" variant="outline" width="full"><a href={bookMeetingHref} rel="noopener noreferrer" target="_blank"><LuCalendar />{bookMeetingLabel}</a></Button> : null;
    $[86] = bookMeetingHref;
    $[87] = bookMeetingLabel;
    $[88] = engagement.isAI;
    $[89] = t17;
  } else {
    t17 = $[89];
  }
  let t18;
  if ($[90] !== engagement.isAI || $[91] !== profileHref) {
    t18 = profileHref && !engagement.isAI ? <Button asChild={true} size="sm" variant="ghost" width="full"><NextLink href={profileHref}>View full profile</NextLink></Button> : engagement.isAI ? <><Button size="sm" variant="outline" width="full" onClick={() => setWilWhoIsOpen(true)}>Who is Wil.ai?</Button><Badge alignSelf="center" colorPalette="green" variant="subtle">Free · Always on</Badge></> : null;
    $[90] = engagement.isAI;
    $[91] = profileHref;
    $[92] = t18;
  } else {
    t18 = $[92];
  }
  let t19;
  if ($[93] !== t15 || $[94] !== t16 || $[95] !== t17 || $[96] !== t18) {
    t19 = <VStack align="stretch" gap={2}>{t15}{t16}{t17}{t18}</VStack>;
    $[93] = t15;
    $[94] = t16;
    $[95] = t17;
    $[96] = t18;
    $[97] = t19;
  } else {
    t19 = $[97];
  }
  let t20;
  if ($[98] !== engagement.isAI || $[99] !== wilWhoIsOpen) {
    t20 = engagement.isAI ? <WilWhoIsModal open={wilWhoIsOpen} onOpenChange={setWilWhoIsOpen} /> : null;
    $[98] = engagement.isAI;
    $[99] = wilWhoIsOpen;
    $[100] = t20;
  } else {
    t20 = $[100];
  }
  let t21;
  if ($[101] !== T0 || $[102] !== t10 || $[103] !== t11 || $[104] !== t12 || $[105] !== t13 || $[106] !== t14 || $[107] !== t19 || $[108] !== t20 || $[109] !== t8 || $[110] !== t9) {
    t21 = <T0 align={t8} gap={t9} width={t10}>{t11}{t12}{t13}{t14}{t19}{t20}</T0>;
    $[101] = T0;
    $[102] = t10;
    $[103] = t11;
    $[104] = t12;
    $[105] = t13;
    $[106] = t14;
    $[107] = t19;
    $[108] = t20;
    $[109] = t8;
    $[110] = t9;
    $[111] = t21;
  } else {
    t21 = $[111];
  }
  return t21;
};
function _temp(a, b) {
  return (b?.experienceStrength ?? 0) - (a?.experienceStrength ?? 0);
}
function _temp2(industry) {
  return industry.title;
}
function _temp3(category) {
  return <Badge key={category.id} colorPalette="purple" size="sm" variant="subtle">{category.title}</Badge>;
}
function _temp4(skill) {
  return <Badge key={skill.id} colorPalette="cyan" size="sm" variant="subtle">{skill.title}</Badge>;
}